import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { useRecoilState } from 'recoil';
import { LoadScript } from '@react-google-maps/api';
import { CategoryProvider } from './context/CategoryProvider';
import { DrawerFilterProvider } from './context/DrawerFilterProvider';

import Routes from './routes/index';
import { RefreshToken } from './services/Login.service';
import { location as locationAtom } from './store/location';

const App = ({ position }) => {
    const [location, setLocation] = useRecoilState(locationAtom);

    useEffect(() => {
        RefreshToken();
    }, []);

    useEffect(() => {
        if (position) {
            setLocation({
                ...location,
                position: {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                    altitude: position.coords.altitude,
                    altitudeAccuracy: position.coords.altitudeAccuracy,
                    heading: position.coords.heading,
                    speed: position.coords.speed,
                },
            });
        }
    }, [position]);

    return (
        <LoadScript
            id="script-loader"
            googleMapsApiKey={process.env.REACT_APP_MAP_KEY}
            language="pt-br"
            region="us"
            libraries={['drawing', 'places']}
        >
            <CategoryProvider>
                <DrawerFilterProvider>
                    <Routes />
                    <ToastContainer />
                </DrawerFilterProvider>
            </CategoryProvider>
        </LoadScript>
    );
};

export default App;
